import Swiper from 'swiper';

export default class Store {
    constructor() {

    }

    init() {
        //console.log("store initialised");
    }

    list() {
        //console.log("store list initialised");
    }

    detail() {
        this.initCarousel();
    }

    finalize() {
        //console.log("store finalized");
    }

    initCarousel() {
        this.carousel =  new Swiper('#detailCarousel', {
            spaceBetween: 20,
            loop: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            }
        });
    }
}